/**
 * Namespace describing something to track
 * @public
 */
export var Trackable;
(function (Trackable) {
    class RevocableController {
        #isRevoked = false;
        #delegate;
        #childTrackers = [];
        constructor(delegate) {
            this.#delegate = delegate;
        }
        setContext(context) {
            this.assertNonRevoked();
            return this.#delegate.setContext(context);
        }
        track(nameOrManager, data) {
            this.assertNonRevoked();
            if (typeof nameOrManager === 'function') {
                // if the manager starts tracking something
                const closer = this.#delegate.track(nameOrManager);
                this.#childTrackers.push(closer);
                return closer;
            }
            return this.#delegate.track(nameOrManager, data);
        }
        get config() {
            this.assertNonRevoked();
            return this.#delegate.config;
        }
        get isRevoked() {
            return this.#isRevoked;
        }
        revoke() {
            if (this.#isRevoked)
                return;
            this.#isRevoked = true;
            while (this.#childTrackers.length > 0) {
                const closer = this.#childTrackers.pop();
                closer();
            }
        }
        assertNonRevoked() {
            if (this.#isRevoked)
                throw new Error('The tracker is closed');
        }
    }
    /** Setup of Trackable */
    function setup(controller, manager) {
        const revocableController = new RevocableController(controller);
        const cleanup = manager(revocableController);
        return () => {
            if (revocableController.isRevoked)
                return;
            try {
                cleanup?.();
            }
            finally {
                revocableController.revoke();
            }
        };
    }
    Trackable.setup = setup;
})(Trackable || (Trackable = {}));
//# sourceMappingURL=Trackable.js.map